import React from "react";
import {
  CANCELLATION_POLICY_SUMMARY,
  isCancellationAllowed,
} from "../../utils/cancellationPolicy";

interface Props {
  compact?: boolean;
}

export default function CancellationPolicy({ compact = false }: Props) {
  const allowed = isCancellationAllowed();

  if (compact) {
    return (
      <p className="text-sm text-slate-600 rounded-sm border border-slate-200 bg-slate-50 px-3 py-2">
        <strong className="text-slate-800">Cancellation policy:</strong>{" "}
        {CANCELLATION_POLICY_SUMMARY}
        {!allowed && (
          <span className="block mt-1 text-amber-800 font-medium">
            The cancellation deadline has passed. Refunds are no longer available.
          </span>
        )}
      </p>
    );
  }

  return (
    <section className="rounded-sm border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-700">
      <h3 className="text-base font-semibold text-slate-900 mb-2">
        Cancellation policy
      </h3>
      <p className="leading-relaxed">{CANCELLATION_POLICY_SUMMARY}</p>
      {!allowed && (
        <p className="mt-3 text-amber-800 font-medium">
          The cancellation deadline has passed. Refunds are no longer available.
        </p>
      )}
    </section>
  );
}
